import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import dataModel from '../../models/DataModel';
import CheckBox from '../CheckBox';
import './FileIntegrationTypes.scss';

export default class FileIntegrationTypes extends React.Component {
  
  constructor(props) {
    FileIntegrationTypes.propTypes = {
      company: PropTypes.object.isRequired,
    };
    super(props);
    this.toggleFileIntegration = this.toggleFileIntegration.bind(this);
  }

  toggleFileIntegration(checked, dataSource, e) {
    const { company } = this.props;
    const clonedCompany = _.cloneDeep(company);
    let fileIntegrations = clonedCompany.features && clonedCompany.features.file_integration ? clonedCompany.features.file_integration.integrations : null;
    if (fileIntegrations) {
      let updateNeeded = false;
      fileIntegrations.forEach(file_integration => {
        if (file_integration.type == dataSource) {
          file_integration.enabled = checked;
          updateNeeded = true;
        }
      });
      if (updateNeeded) {
        dataModel.companiesDAO.updateCompany(clonedCompany);
      }
    }
  }

  render() {
    const { company } = this.props;
    let egnyteCheck = null;
    let googleCheck = null;
    let fileIntegrations = company.features && company.features.file_integration ? company.features.file_integration.integrations : null;
    if (fileIntegrations) {
      fileIntegrations.forEach(file_integration => {
        if (file_integration.type == 'egnyte') {
          egnyteCheck = (
            <div className="file-integration-types__check">
              <CheckBox className="file-integration-types__egnyte-check" key='file-integration-type-egnyte' checked={file_integration.enabled} dataSource="egnyte" toggleCheckBox={this.toggleFileIntegration}/>
              <div className="file-integration-types__egnyte-text">Egnyte</div>
            </div>
          );
        }
        else if (file_integration.type == 'google') {
          googleCheck = (
            <div className="file-integration-types__check">
              <CheckBox className="file-integration-types__google-check" key='file-integration-type-google' checked={file_integration.enabled} dataSource="google" toggleCheckBox={this.toggleFileIntegration}/>
              <div className="file-integration-types__google-text">Google Drive</div>
            </div>
          );
        }
      });
    }
    return (
      <div className="file-integration-types">
        {egnyteCheck}
        {googleCheck}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/FileIntegrationTypes/index.js